import { defineComponent as l, createBlock as t, openBlock as r, unref as m, mergeProps as p, withCtx as c, createElementVNode as a } from "vue";
import { RevIcon as d } from "@ds/components/Icon";
const v = /* @__PURE__ */ l({
  name: "IconRecommendation",
  __name: "IconRecommendation",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (i, e) => (r(), t(m(d), p(n, { "view-box": "0 0 24 24" }), {
      default: c(() => e[0] || (e[0] = [
        a("path", { d: "M12.448 5.908a.5.5 0 0 0-.896 0l-.905 1.834a.5.5 0 0 1-.377.273L8.247 8.31A.5.5 0 0 0 7.97 9.162l1.464 1.427a.5.5 0 0 1 .144.443l-.346 2.015a.5.5 0 0 0 .726.527l1.81-.952a.5.5 0 0 1 .465 0l1.81.952a.5.5 0 0 0 .725-.527l-.346-2.015a.5.5 0 0 1 .144-.443l1.464-1.427a.5.5 0 0 0-.277-.853L13.73 8.015a.5.5 0 0 1-.377-.273l-.905-1.834" }, null, -1),
        a("path", {
          "fill-rule": "evenodd",
          d: "M21.75 14.5v-9a3.25 3.25 0 0 0-3.25-3.25h-13A3.25 3.25 0 0 0 2.25 5.5v9a3.25 3.25 0 0 0 3.25 3.25h.75V21a.75.75 0 0 0 1.219.586l4.794-3.836H18.5a3.25 3.25 0 0 0 3.25-3.25m-1.5-9v9a1.75 1.75 0 0 1-1.75 1.75h-6.325a1.25 1.25 0 0 0-.78.274L7.75 19.439V17.5a1.25 1.25 0 0 0-1.25-1.25h-1a1.75 1.75 0 0 1-1.75-1.75v-9A1.75 1.75 0 0 1 5.5 3.75h13a1.75 1.75 0 0 1 1.75 1.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])),
      _: 1,
      __: [0]
    }, 16));
  }
});
export {
  v as default
};
